<template>
  <div>
    <ul>
      <li><router-link :to="{ name: 'bracan' }">ブラキャン予約</router-link></li>
      <li><router-link :to="{ name: 'rentaltent' }">レンタルテント予約</router-link></li>
    </ul>
  </div>
</template>
